import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import Checkbox from 'apollo-react/components/Checkbox';
import FormGroup from 'apollo-react/components/FormGroup';
import Grid from 'apollo-react/components/Grid';
import Radio from 'apollo-react/components/Radio';
import RadioGroup from 'apollo-react/components/RadioGroup';
import TextField from 'apollo-react/components/TextField';
import Typography from 'apollo-react/components/Typography';
import qs from 'query-string';
import React from 'react';

import NavigateLink from '../../../components/NavigateLink';
import RadioButtonListLabel from '../../../components/RadioButtonListLabel';
import SavedSearchesTable from '../../../components/SavedSearchesTable';
import withTranslation from '../../../components/withTranslation';
import { DOCUMENT_VIEWER, ENTITY_DISPLAY } from '../../../constants/Urls';
import NavigateLinkCell from '../../FindPage/NavigateLinkCell';

const useStyles = makeStyles({
  container: {
    padding: 24,
  },
  scrollView: {
    height: 'calc(100vh - 72px)',
    overflowY: 'auto',
  },
});

const DocumentSearchPage = ({ translateString, selectedRepositoryItem = {} }) => {
  const classes = useStyles();

  const { repositoryName, queryName } = selectedRepositoryItem;

  const searchMetadata = {
    url: '/getdocumentrepositorysearchdata',
    params: {
      repositoryName,
      queryName,
      needAllDocuments: false,
    },
  };

  const extraColumns = [
    {
      index: 0,
      header: '',
      fixedWidth: true,
      customCell: ({ row }) => {
        const link = `${DOCUMENT_VIEWER}?${qs.stringify({
          entityType: row.EntityType,
          docId: row.ItmId,
        })}`;
        return <NavigateLink to={link}>{'View'}</NavigateLink>;
      },
    },
  ];

  return (
    <div className={classes.scrollView}>
      <Grid container className={classes.container}>
        <Grid item xs={12}>
          <Typography variant="h2" gutterBottom>
            {translateString('Search')}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField required label="Search in documents for" fullWidth />

          <FormGroup>
            <RadioGroup row name="option1">
              <Radio value="1" label="Either Word" />
              <Radio value="2" label="All Words" checked={false} />
              <Radio value="3" label="Exact Phrase" />
            </RadioGroup>
          </FormGroup>

          <Typography variant="body2">
            {`Quotes &quot; &quot; may be used to search for an exact word or phrase. For example,
            when &quot;valid&quot; is entered, the search will return only those records containing
            the word valid. An asterisk * may be used at the end of a word to expand the result. For
            example, when valid* is entered, the search will return any records containing valid,
            validation, validate, etc. Brackets {} may be used to perform a combined search that
            contains multiple words or phrases by enclosing the values in the brackets separated by
            commas. For example, when &#123;(validation, script, process)&#125; is entered, the
            search will return any records that contain all three words.`}
          </Typography>

          <RadioButtonListLabel translatedLabel="Include in search:" />
          <FormGroup row>
            <Checkbox label="Document Content" />
            <Checkbox label="Category" />
            <Checkbox label="Access History" />
            <Checkbox label="Distribution List" />
          </FormGroup>

          <Button variant="primary" style={{ marginTop: 16 }}>
            {'Search'}
          </Button>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 32 }}>
          <SavedSearchesTable
            title={queryName}
            metadata={searchMetadata}
            entityName={repositoryName}
            initialSearchName={queryName}
            rowsPerPage={20}
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
            showSearchSelector={false}
            enableSorting
            customCell={NavigateLinkCell.forUrl(ENTITY_DISPLAY)}
            extraColumns={extraColumns}
            enableSaving
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default withTranslation(DocumentSearchPage);
